import { render, staticRenderFns } from "./Partner.Detail.Summary.vue?vue&type=template&id=8f745066&"
import script from "./Partner.Detail.Summary.vue?vue&type=script&lang=js&"
export * from "./Partner.Detail.Summary.vue?vue&type=script&lang=js&"
import style0 from "./Partner.Detail.Summary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports